import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/jan-feb-2023/sponsors/Eccles-Symphony-ad.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'George S. and Dolores Doré Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/carmina-burana.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Carmina Burana',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/red-rock.jpg',
      link: 'https://redrockbrewing.com/',
      alt: 'Red Rock Brewery',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/ruths-chris.jpg',
      link: 'https://www.ruthschris.com/restaurant-locations/salt-lake-city/',
      alt: 'Ruths Chris',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/thierrys-return.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Thierrys Return',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/noorda.jpg',
      link: 'https://www.uvu.edu/thenoorda',
      alt: 'UVU The Noorda',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/pre-concert.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Pre-concert Talks',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/grand-america.jpg',
      link: 'https://www.laurelslc.com/',
      alt: 'Laurel Brasserie and Bar',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/upcoming-season.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Utah Symphony Upcoming Season',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/sponsors/ufs.jpg',
      link: 'https://utahfoodservices.com/',
      alt: 'Utah Food Services',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
